import { EventBase } from "@vp/models";

export class CaseUpdatedEvent extends EventBase<string> {
  constructor(message: string) {
    super();
    this.args = message;
  }
}
